import { STORE_BUSINESS_INFO } from "@/store/store-business-info";
import styles from "./business-info.module.css";

interface BusinessInfoProps {
  /** 스토어 푸터 등 배경이 밝은 곳은 "default", 로그인 푸터(회색 배경)는 "muted" */
  tone?: "default" | "muted";
}

/**
 * 사업자 신원 표시 — 전자상거래법 제10조가 요구하는 항목을 한 덩어리로 렌더링한다.
 * 사이버몰 **초기 화면(로그인 페이지)** 과 스토어 화면 하단에 공통으로 쓴다.
 * 상호·대표자·사업자등록번호·주소·전화·이메일. (통신판매업 신고번호는 신고 후 추가 예정)
 */
export default function BusinessInfo({ tone = "default" }: BusinessInfoProps) {
  const info = STORE_BUSINESS_INFO;
  return (
    <div className={`${styles.wrap} ${tone === "muted" ? styles.muted : ""}`}>
      <div className={styles.row}>
        <span className={styles.company}>{info.companyName}</span>
        <span>대표자 : {info.ceoName}</span>
        <span>사업자등록번호 : {info.businessRegistrationNumber}</span>
      </div>
      <div className={styles.row}>
        <span>주소 : {info.address}</span>
        <span>고객센터 : {info.customerServicePhone}</span>
        <span>이메일 : {info.customerServiceEmail}</span>
      </div>
    </div>
  );
}
